<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import { rolesActions, usersActions, logsActions } from '@state/helpers'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Logs',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      title: 'Logs',
      params: {
        page: 1,
        roleId: '',
        userIds: '',
        startDate: '',
        endDate: '',
      },
      loading: true,
      dateRange: '',
      userFilters: [],
      roles: [],
      users: [],
      logs: [],
    }
  },
  mounted() {
    this.fetchRoles()
    this.fetchUsers()
    this.fetchLogs()
  },
  methods: {
    ...rolesActions,
    ...usersActions,
    ...logsActions,
    async fetchRoles() {
      let res = await this.getRoles()
      this.roles = res.data
      this.roles.unshift({
        id: '',
        roles: 'All',
      })
    },
    async fetchUsers() {
      let res = await this.getUsers({ page: 1 })
      this.users = res.data
      this.users.unshift({
        id: '',
        userDetail: {
          name: 'All',
        },
      })
    },
    async fetchLogs() {
      this.loading = true
      let params = this.$options.filters.cleanObject(this.params)
      let res = await this.getLogs(params)
      this.logs = res.data
      this.loading = false
    },
    onChangeDate() {
      this.params.startDate = this.$options.filters.parseDate(this.dateRange[0], 'DD-MM-YYYY')
      this.params.endDate = this.$options.filters.parseDate(this.dateRange[1], 'DD-MM-YYYY')

      this.fetchLogs()
    },
    onChangeUsers() {
      this.params.userIds = this.userFilters.join(',')
      this.fetchLogs()
    },
    menuObject(output) {
      const { menuObject } = this.$route.query
      return JSON.parse(window.atob(menuObject))[output]
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <!-- Top Section -->
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-card-title>
            <h5 class="card-title font-size-16">Filter Log History Users</h5>
            <hr />
          </b-card-title>
          <b-card-body>
            <b-row>
              <b-col md="9">
                <b-row>
                  <b-col md="4">
                    <b-form-group label="Date Range" label-for="dateRange">
                      <date-picker
                        v-model="dateRange"
                        type="date"
                        range
                        placeholder="Select date range"
                        format="DD-MM-YYYY"
                        @change="onChangeDate"
                      ></date-picker>
                    </b-form-group>
                  </b-col>
                  <b-col md="3">
                    <b-form-group label="Role" label-for="role">
                      <v-select
                        v-model="params.roleId"
                        label="roles"
                        :options="roles"
                        :reduce="(role) => role.id"
                        placeholder="Select Role"
                        @input="fetchLogs"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                  <b-col md="4">
                    <b-form-group label="User" label-for="user">
                      <v-select
                        v-model="userFilters"
                        multiple
                        :getOptionLabel="(user) => user.userDetail.name"
                        :options="users"
                        :reduce="(user) => user.id"
                        placeholder="Select User"
                        @input="onChangeUsers"
                      ></v-select>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
              <b-col md="3" class="text-right"
                v-if="menuObject('export')">
                <button class="btn btn-primary mt-4 mr-1"
                  ><i class="fa fa-file-excel"></i> Export</button
                >
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-card-title>
            <h5 class="card-title font-size-16">Log History Users</h5>
            <hr />
          </b-card-title>
          <b-card-body>
            <div v-if="loading" class="text-center my-5">
              <b-spinner type="grow" label="Spinning"></b-spinner>
            </div>
            <template v-else>
              <div class="table-responsive" v-if="logs.length > 0">
                <table class="table mb-0 table-striped table-hover">
                  <thead class="thead-dark">
                    <tr>
                      <th width="5%" class="text-center">No</th>
                      <th width="15%">Date</th>
                      <th width="20%">User</th>
                      <th width="15%">Role</th>
                      <th width="30%">Aktivitas</th>
                      <th width="15%">IP/Browser</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in logs" :key="index">
                      <td class="text-center">{{ index + 1 }}</td>
                      <td>{{ item.date }}</td>
                      <td>{{ item.name }}</td>
                      <td>{{ item.role }}</td>
                      <td>{{ item.activity }}</td>
                      <td>{{ item.ip }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p v-else class="text-center my-5">No logs data found.</p>
            </template>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
  </Layout>
</template>
